import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var ChevronRight = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg",
        "stroke": "currentColor",
        "strokeLinecap": "round",
        "strokeLinejoin": "round",
    };
    return (React.createElement(StyledIconBase, __assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("polyline", { points: "9 18 15 12 9 6", key: "k0" })));
});
ChevronRight.displayName = 'ChevronRight';
export var ChevronRightDimensions = { height: 24, width: 24 };
